const regionData = {
    "valley4": {
        name: "Valley 4",
        power: 200,
        income: {
            "Originium_Ore": 560,
            "Amethyst_Ore": 240,
            "Ferrium_Ore": 1080
        }
    },
    "wuling": {
        name: "Wuling",
        power: 200,
        income: {
            "Originium_Ore": 540,
            "Amethyst_Ore": 0,
            "Ferrium_Ore": 90,
            "Cuprium_Ore": 240
        }
    },
}

export { regionData };